<script>
  import { SvelteDate } from 'svelte/reactivity';
  let {
    dateRange = $bindable({
      min: undefined,
      max: undefined,
    }),
  } = $props();

  function formatDate(date) {
    return (
      date.getFullYear() +
      '/' +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      '/' +
      (date.getDate() + 1).toString().padStart(2, '0')
    );
  }

  function subtractMonth(date, months) {
    let newDate = new SvelteDate(date);
    let d = date.getDate();
    newDate.setMonth(date.getMonth() - months);
    if (date.getDate() != d) {
      newDate.setDate(0);
    }
    return newDate;
  }

  const presets = $derived.by(() => {
    const p = [];

    const now = new SvelteDate();

    {
      let minDate = subtractMonth(now, 1);
      p.push({
        label: '1M',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }

    {
      let minDate = subtractMonth(now, 3);
      p.push({
        label: '3M',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }

    {
      let minDate = subtractMonth(now, 6);
      p.push({
        label: '6M',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }
    {
      let minDate = new SvelteDate(now);
      minDate.setDate(0);
      minDate.setMonth(0);
      p.push({
        label: 'YTD',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }
    {
      let minDate = new SvelteDate(now);
      minDate.setFullYear(minDate.getFullYear() - 1);
      p.push({
        label: '1Y',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }
    {
      let minDate = new SvelteDate(now);
      minDate.setFullYear(minDate.getFullYear() - 2);
      p.push({
        label: '2Y',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }
    {
      let minDate = new SvelteDate(now);
      minDate.setFullYear(minDate.getFullYear() - 3);
      p.push({
        label: '3Y',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }
    {
      let minDate = new SvelteDate(now);
      minDate.setFullYear(minDate.getFullYear() - 5);
      p.push({
        label: '5Y',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }
    {
      let minDate = new SvelteDate(now);
      minDate.setFullYear(minDate.getFullYear() - 10);
      p.push({
        label: '10Y',
        min: formatDate(minDate),
        max: formatDate(now),
      });
    }

    p.push({
      label: 'All',
      min: undefined,
      max: undefined,
    });

    return p;
  });

  function setPreset(preset) {
    dateRange.min = preset.min;
    dateRange.max = preset.max;
  }
</script>

<div class="dynamic-date-filter-bar">
  {#each presets as preset, i (i)}
    <button onclick={() => setPreset(preset)}>{preset.label}</button>
  {/each}
</div>
